/* eslint-disable react/prefer-stateless-function,null,react/no-unused-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OpacityPreLoader from 'components/Common/PreLoaders/OpacityPreLoader';
import MessengerService from 'mt-react-common/modules/messenger/services/MessengerService/MessengerService';
import * as _ from 'lodash';

import UsersViewedMessageBlock from './_messages/UsersViewedMessageBlock';

import TextMessageItem from './_messages/TextMessageItem';
import RenameGroupNoticeMessageItem from './_messages/RenameGroupNoticeMessageItem';
import NewUsersToRoomNoticeMessageItem from './_messages/NewUsersToRoomNoticeMessageItem';
import RemoveUsersToRoomNoticeMessageItem from './_messages/RemoveUsersToRoomNoticeMessageItem';
import CreateGroupNoticeMessageItem from './_messages/CreateGroupNoticeMessageItem';
import MemberLiveGroupNoticeMessageItem from './_messages/MemberLiveGroupNoticeMessageItem';

class RoomMessages extends Component {
  state = { lastViewedMessagesByUsers: {} };

  async componentDidMount() {
    await this.updateLastViewedMessagesByUsers();
  }

  setStateAsync(state) {
    return new Promise(resolve => {
      this.setState(state, resolve);
    });
  }

  updateLastViewedMessagesByUsers = async () => {
    const result = await MessengerService.getLastViewedMessagesByUsers(
      {},
      this.props.room.roomUuid
    );
    this.setStateAsync({
      lastViewedMessagesByUsers: _.groupBy(
        result.destructData,
        'last_viewed_message_id'
      )
    });
  };

  render() {
    if (
      this.props.messagesRequestState.inProgress &&
      this.props.messagesItemsIds.length === 0
    ) {
      return <OpacityPreLoader />;
    }
    if (this.props.messagesItemsIds.length > 0) {
      return (
        <div className="panel-body">
          {this.props.messagesPagination.currentPage !==
            this.props.messagesPagination.pageCount &&
          this.props.messagesPagination.totalCount > 0 ? (
            <div className="alert alert-default text-center">
              {this.props.messagesRequestState.inProgress ? (
                <OpacityPreLoader />
              ) : null}
              <a
                href=""
                onClick={e => {
                  e.preventDefault();
                  this.props.showMoreMessages();
                }}
              >
                Загрузить прошлые сообщения
              </a>
            </div>
          ) : null}
          {this.props.messagesItemsIds
            .slice()
            .reverse()
            .map(itemId => {
              const message = this.props.getMessageById(itemId);
              let messageItem = (
                <TextMessageItem
                  key={`roomMessage-${message.id}`}
                  auntUserId={this.props.auntUserId}
                  message={message}
                  lastViewedMessagesByUsers={
                    this.state.lastViewedMessagesByUsers
                  }
                />
              );

              if (message.messageMeta) {
                if (message.messageMeta.type === 'renameRoom') {
                  messageItem = (
                    <RenameGroupNoticeMessageItem message={message} />
                  );
                } else if (message.messageMeta.type === 'addUsersToRoom') {
                  messageItem = (
                    <NewUsersToRoomNoticeMessageItem message={message} />
                  );
                } else if (message.messageMeta.type === 'removeUsersFromRoom') {
                  messageItem = (
                    <RemoveUsersToRoomNoticeMessageItem message={message} />
                  );
                } else if (message.messageMeta.type === 'createRoom') {
                  messageItem = (
                    <CreateGroupNoticeMessageItem message={message} />
                  );
                } else if (message.messageMeta.type === 'ownerLiveRoom') {
                  messageItem = (
                    <MemberLiveGroupNoticeMessageItem message={message} />
                  );
                }
              }
              return (
                <div
                  className="media media_comment media_comment_default"
                  key={`roomMessage-${message.id}`}
                >
                  {messageItem}
                  <UsersViewedMessageBlock
                    message={message}
                    lastViewedMessagesByUsers={
                      this.state.lastViewedMessagesByUsers
                    }
                    auntUserId={this.props.auntUserId}
                  />
                </div>
              );
            })}
        </div>
      );
    }
    return (
      <div className="alert alert-default text-center" style={{ margin: 0 }}>
        <p>Нет сообщений.</p>
      </div>
    );
  }
}

RoomMessages.propTypes = {
  room: PropTypes.shape({
    roomUuid: PropTypes.string.isRequired
  }).isRequired,
  auntUserId: PropTypes.number.isRequired,
  messagesItemsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  getMessageById: PropTypes.func.isRequired,
  showMoreMessages: PropTypes.func.isRequired,
  messagesPagination: PropTypes.shape({
    currentPage: PropTypes.number.isRequired,
    pageCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired
  }).isRequired,
  messagesRequestState: PropTypes.shape({
    inProgress: PropTypes.bool.isRequired
  }).isRequired
};

export default RoomMessages;



// WEBPACK FOOTER //
// ./src/components/Messenger/content/RoomViewBlock/RoomMainBlock/RoomMessages.js